import React from 'react';
import {
  SoldButton,
  IfSaleButton,
  NoSaleButton,
} from 'components/project/ClerkScreen';

import { Container } from './Styles';

const DecisionButtons = () => (
  <Container>
    <SoldButton />
    <IfSaleButton />
    <NoSaleButton />
  </Container>
);

export default DecisionButtons;
